import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.scss'],
})
export class UserParkingConfirmModalComponent implements OnInit {
    money: number | undefined;
    user: string | undefined;
    constructor(
        public dialogRef: MatDialogRef<UserParkingConfirmModalComponent>,
        private translate: TranslateService,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
        this.money = data.money;
        this.user = data.user;
    }

    ngOnInit(): void {}

    okAddIt() {
        this.dialogRef.close({ event: 'OK' });
    }

    closeClick(): void {
        this.dialogRef.close({ event: 'Cancel' });
    }
}
